/**
 * hpq-jdgm-carousel-swipe.js
 * HPQ: Add touch-swipe navigation to Judge.me carousel widgets.
 *
 * Why: Judge.me's `assets/carousels.js` registers a ResizeObserver that calls
 * `window.jdgmHideArrows` when the widget is narrow (<818px), and ships zero
 * touch/swipe handlers. On mobile that combination strands the user — arrows
 * are gone AND swipe doesn't work, so they can only see the first card.
 *
 * What this does:
 *   1. Attaches touchstart/touchend listeners to every Judge.me carousel
 *      (cards / videos / testimonials variants).
 *   2. On a horizontal swipe, synthesizes a click on the appropriate arrow
 *      button — reuses Judge.me's existing `window.jdgmNextCard` /
 *      `window.jdgmPreviousCard` API via the inline onclick attributes.
 *   3. CSS in custom.css restores arrow visibility on mobile so users have
 *      both swipe AND tap-to-page affordances.
 *
 * Loading: <script defer> from snippets/theme-globals.liquid.
 */

(function () {
  'use strict';

  var SELECTOR =
    '.jdgm-cards-carousel, .jdgm-videos-carousel, .jdgm-testimonials-carousel';
  var SWIPE_THRESHOLD = 40; // min horizontal pixels to count as a swipe
  var SWIPE_TIME_LIMIT = 600; // max ms between touchstart and touchend
  var ATTACHED_FLAG = '__hpqSwipeAttached';

  function attachSwipe(carousel) {
    if (carousel[ATTACHED_FLAG]) return;
    carousel[ATTACHED_FLAG] = true;

    var startX = 0;
    var startY = 0;
    var startTime = 0;

    carousel.addEventListener(
      'touchstart',
      function (e) {
        var t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        startTime = Date.now();
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      function (e) {
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        var dt = Date.now() - startTime;

        // Reject taps, long-presses, and primarily-vertical motions
        if (dt > SWIPE_TIME_LIMIT) return;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(dx) * 0.7) return;

        var arrows = carousel.querySelectorAll('.jdgm-arrow');
        if (arrows.length < 2) return;

        // Identify arrows by the onclick attribute Judge.me writes inline.
        // Fallback to positional [0] = prev / [1] = next.
        var prev = arrows[0];
        var next = arrows[1];
        for (var i = 0; i < arrows.length; i++) {
          var oc = (arrows[i].getAttribute('onclick') || '').toLowerCase();
          if (oc.indexOf('next') >= 0) next = arrows[i];
          else if (oc.indexOf('previous') >= 0 || oc.indexOf('prev') >= 0) {
            prev = arrows[i];
          }
        }

        // Swipe left → next card. Swipe right → previous card.
        if (dx < 0) next.click();
        else prev.click();
      },
      { passive: true }
    );
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(attachSwipe);
  }

  // Initial scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Judge.me's loader injects the widget async; watch for late mounts and
  // disconnect after 30s (well past any reasonable hydration window).
  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
  }, 30000);
})();
